import { APP_INITIALIZER } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';

export function restoreAuthSession(
  authService: AuthService,
  configService: ConfigService,
): () => Promise<void> {
  return async () => {
    await configService.loadAppConfig();
    await authService.restoreSession();
  };
}

export const authInitializerProvider = {
  provide: APP_INITIALIZER,
  useFactory: restoreAuthSession,
  multi: true,
  deps: [AuthService, ConfigService],
};
